import { render, staticRenderFns } from "./headerBg.vue?vue&type=template&id=b91e5fba&scoped=true&"
import script from "./headerBg.vue?vue&type=script&lang=js&"
export * from "./headerBg.vue?vue&type=script&lang=js&"
import style0 from "./headerBg.vue?vue&type=style&index=0&id=b91e5fba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91e5fba",
  null
  
)

export default component.exports